import { makeStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

export const useStyles = makeStyles(() =>
  createStyles({
    editButton: {
      height: '30px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '12px',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    editButtonIcon: {
      width: '14px',
      justifyContent: 'start',
      color: '#FFFFFF',
      transform: 'translateX(0px)',
    },
    deleteButtonIcon: {
      width: '17px',
      justifyContent: 'start',
      color: '#FFFFFF',
      transform: 'translate(0px, 0px)',
    },
  }),
);

export const StyledUpdateButton = withStyles(() => ({
  root: {
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    boxShadow: 'none',
    height: '42px',
    minWidth: '145px',
    margin: '5px',
    fontSize: '15px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);
